import { render, staticRenderFns } from "./HostPendingInvoices.vue?vue&type=template&id=70d644ae&"
import script from "./HostPendingInvoices.vue?vue&type=script&lang=js&"
export * from "./HostPendingInvoices.vue?vue&type=script&lang=js&"
import style0 from "./HostPendingInvoices.vue?vue&type=style&index=0&id=70d644ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports